export const calendarFilterTextFieldSx = {
  minWidth: 136,
  maxWidth: 136,
  '& .MuiInputBase-root.Mui-focused .filter-autocomplete-adornment': {
    display: 'none',
  },
  '& .MuiInputLabel-root': {
    fontSize: '14px',
    color: '#707070',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#707070',
  },
  '& .MuiInputBase-input': {
    fontSize: '14px',
    color: '#707070',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#FFFFFF',
  },
  '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E5E1E1',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E5E1E1',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: (theme) => theme.palette.primary.main,
  },
};

export const calendarFilterAutocompleteSx = {
  '& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root': {
    minHeight: 40,
    height: 40,
    flexWrap: 'nowrap',
    alignItems: 'center',
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
  },
  '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
    minWidth: 0,
  },
  '& .MuiAutocomplete-clearIndicator': {
    width: 16,
    height: 16,
    minWidth: 16,
    minHeight: 16,
    padding: 0,
  },
  '& .MuiAutocomplete-clearIndicator .MuiSvgIcon-root': {
    fontSize: 16,
  },
  '& .MuiAutocomplete-option': {
    padding: '8px 16px !important',
    fontSize: '14px !important',
  },
  '& .MuiAutocomplete-option[aria-selected="true"], & .MuiAutocomplete-option[aria-selected="true"]:hover, & .MuiAutocomplete-option.Mui-selected, & .MuiAutocomplete-option.Mui-selected:hover':
    {
      backgroundColor: 'transparent !important',
    },
  '& .MuiAutocomplete-option.Mui-focused, & .MuiAutocomplete-option[aria-selected="true"].Mui-focused, & .MuiAutocomplete-option.Mui-focusVisible':
    {
      backgroundColor: '#F7F7F7 !important',
    },
};

export const calendarFilterCheckboxSx = {
  color: '#A1A1AA',
};

export const calendarFilterCountChipSx = {
  minWidth: 20,
  height: 20,
  borderRadius: '50%',
  backgroundColor: (theme) => theme.palette.primary.main,
  color: (theme) => theme.palette.primary.contrastText,
  fontSize: '12px',
  fontWeight: 500,
  '& .MuiChip-label': {
    padding: 0,
    lineHeight: 1,
  },
};
